"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSEPConfirmationComponent = void 0;
const router_1 = require("@angular/router");
const expresspay_services_1 = require("../../../shared/services/expresspay.services");
const helper_service_1 = require("../../../../mma/shared/services/helper.service");
const shared_1 = require("../../../../mma/shared");
const cs_thirdpartypayments_web_1 = require("@cspire/cs-thirdpartypayments-web");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const common_1 = require("@angular/common");
class CSEPConfirmationComponent {
    constructor(genericContentServiceV2, expressPayService, helperService, router, currencyPipe) {
        this.genericContentServiceV2 = genericContentServiceV2;
        this.expressPayService = expressPayService;
        this.helperService = helperService;
        this.router = router;
        this.currencyPipe = currencyPipe;
        this.classes = 'col-12';
        this.today = Date.now();
    }
    ngOnInit() {
        this.scrollTop();
        this.getAccountDetails();
        this.getGenericContent();
    }
    getAccountDetails() {
        this.loader = true;
        this.expressPayService.getPersonalInformation().subscribe((res) => {
            this.personalInfo = res;
            this.loader = false;
            this.error = null;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    // eslint-disable-next-line brace-style
    printThisSection() {
        document.getElementById('startOver').style.display = 'none';
        document.getElementById('returnToExpressPay').style.display = 'none';
        document.getElementById('printReceipt').style.display = 'none';
        this.billingInfo = document.querySelector('cs-ep-confirmation').innerHTML;
        const popupWindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
        popupWindow.document.open();
        popupWindow.document.write('<html><head><link href="/resources/css/compiled-css/expresspay/expresspay.css" rel="stylesheet"/></head><body>' +
            this.billingInfo + '<script type="text/javascript">window.print();setTimeout(function() {window.close();}, 500)</script></html>');
        popupWindow.document.close();
        document.getElementById('startOver').style.display = 'block';
        document.getElementById('returnToExpressPay').style.display = 'block';
        document.getElementById('printReceipt').style.display = 'block';
    }
    getGenericContent() {
        const genericContentIds = [
            this.genericError,
            'genericConfirmConvenienceAmnt'
        ];
        this.genericContentServiceV2.getBulkGenericContent(genericContentIds).subscribe((bulkGenericContent) => {
            this.genericContentItem = bulkGenericContent;
            for (const genericContent of bulkGenericContent) {
                switch (genericContent.id) {
                    case this.genericError:
                        this.genericError904 = genericContent.content;
                        break;
                    case 'genericConfirmConvenienceAmnt':
                        this.genericConfirmConvenienceAmnt = genericContent.content;
                        this.genericConfirmConvenienceAmnt = this.genericConfirmConvenienceAmnt.toString()
                            .replace('Convenience_Amount', this.currencyPipe.transform((this.convenienceAmount), 'USD'));
                        break;
                    default:
                        break;
                }
            }
        }, (error) => { });
    }
    toExpressPay() {
        location.reload();
    }
    scrollTop() {
        window.scrollTo(0, 200);
    }
    openFeesTooltip() {
        this.convenienceTooltip.open();
    }
    closeFeesTooltip() {
        this.convenienceTooltip.close();
    }
}
exports.CSEPConfirmationComponent = CSEPConfirmationComponent;
//# sourceMappingURL=confirmation.component.js.map